import { Button, Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import tryDemoUpperBg from "../../Images/TgaTryDemoUpperBg.png";
import tgaLogo from "../../Images/tgaLogoNew.png";

interface TryDemoProps {
    isButtonDisabled: boolean,
    onTryDemoClickFunction: () => void
}

function TryDemoComponent(props: TryDemoProps) {
    const { t } = useTranslation();

    return (
        <div className="px-[25px] xl:px-[100px] relative w-full flex justify-center bg-#F6F6F6">
            <img src={tryDemoUpperBg} alt="TryDemoUpperBg" className="object-cover h-full min-h-[130px] w-full rounded-tr-[22px] rounded-tl-[22px]" />
            <div className="absolute inset-0 flex flex-col xl:flex-row justify-center items-center gap-4 px-[30px]">
                <div className="flex justify-center items-center gap-2">
                    <img src={tgaLogo} alt="tgaLogo" className="h-[30px] w-[30px] md:h-[40px] md:w-[40px] xl:h-[50px] xl:w-[50px]" />
                    <Typography className="uppercase text-#282828 font-normal text-[14px] md:text-[14px] xl:text-[16px] 2xl:text-[20px] leading-[16px] xl:leading-[20px] 2xl:leading-[24px]">
                        TGA {t("Concept")}
                    </Typography>
                </div>
                <hr className="bg-#282828 w-[1px] hidden xl:block xl:py-[30px]" />
                <Typography className="uppercase text-#282828 font-medium text-[14px] md:text-[16px] xl:text-[20px] 2xl:text-[26px] leading-[12px] xl:leading-[16px] 2xl:leading-[18px] xl:max-w-[450px] 2xl:max-w-none text-center">
                    {t("TheUltimateDWGAndPDFDrawingTool")}
                </Typography>
                <Button id="tryNowBtn" onClick={props.onTryDemoClickFunction} className="bg-#333333 shadow-none hover:bg-#4E4E4E hover:shadow-none min-w-[130px] h-[30px] xl:h-[40px] text-[12px] xl:text-[14px] leading-[12px] xl:leading-[14px] font-medium rounded-[5px] py-0">
                    {t("TryDemo")}
                </Button>
            </div>
        </div>
    );
}

export default TryDemoComponent;